import { render, staticRenderFns } from "./ReprintTab.vue?vue&type=template&id=6a42653a&"
import script from "./ReprintTab.vue?vue&type=script&lang=ts&"
export * from "./ReprintTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports